import { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import api from '../api/client';
import SimpleMarkdown from '../components/SimpleMarkdown';

function checkClass(ok) {
  if (ok === true) return 'quiz-review-check--ok';
  if (ok === false) return 'quiz-review-check--wrong';
  return 'quiz-review-check--unchecked';
}

export default function QuizReviewPage() {
  const { listId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await api.get(`/tasks/lists/${listId}/quiz-review/`);
      setData(res.data);
    } catch (e) {
      const msg = e.response?.data?.detail || 'Не удалось загрузить разбор теста.';
      setError(typeof msg === 'string' ? msg : 'Не удалось загрузить разбор теста.');
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [listId]);

  useEffect(() => {
    void load();
  }, [load]);

  function goBack() {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/my-lessons');
    }
  }

  if (loading) {
    return (
      <div className="quiz-review-page">
        <p className="text-secondary">Загрузка разбора…</p>
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="quiz-review-page">
        <div className="page-header">
          <h1>Разбор теста</h1>
        </div>
        <div className="alert alert-error">{error || 'Тест не найден.'}</div>
        <button type="button" className="link-like" onClick={goBack}>
          ← Назад
        </button>
      </div>
    );
  }

  const questions = Array.isArray(data.questions) ? data.questions : [];
  const total = Number(data.total) || 0;
  const correct = Number(data.correct) || 0;
  const unchecked = Number(data.unchecked) || 0;

  return (
    <div className="quiz-review-page">
      <div className="page-header">
        <h1>{data.title || 'Разбор теста'}</h1>
        <p className="page-subtitle">
          {correct} из {total} верно
          {unchecked > 0 ? `, ${unchecked} без проверки` : ''}
          {data.student_username ? (
            <>
              {' · '}
              @{data.student_username}
            </>
          ) : null}
        </p>
      </div>

      {questions.length === 0 ? (
        <p className="text-secondary">В тесте нет вопросов.</p>
      ) : (
        <ol className="quiz-review-list">
          {questions.map((q) => (
            <li key={q.task_id || q.position} className="quiz-review-card">
              <header className="quiz-review-card-head">
                <strong>Вопрос {q.position}</strong>
                <span className={`quiz-review-check ${checkClass(q.answer_check_ok)}`}>
                  {q.check_label || 'не проверено'}
                </span>
                <span className="quiz-review-mark" title="Самооценка">
                  {q.mark || '—'}
                </span>
              </header>
              {q.title ? (
                <div className="quiz-review-task-title text-secondary">{q.title}</div>
              ) : null}
              <SimpleMarkdown className="quiz-review-statement" text={q.statement || ''} />
              <div className="quiz-review-answers">
                <div>
                  <div className="quiz-review-label">Ответ ученика</div>
                  <p className="quiz-review-answer-text">
                    {q.student_answer_display || q.student_answer || '—'}
                  </p>
                </div>
                <div>
                  <div className="quiz-review-label">Правильный ответ</div>
                  <p className="quiz-review-answer-text">
                    {q.expected_answer_display || '—'}
                  </p>
                </div>
              </div>
              {q.self_comment ? (
                <div className="quiz-review-comment">
                  <div className="quiz-review-label">Комментарий ученика</div>
                  <p>{q.self_comment}</p>
                </div>
              ) : null}
            </li>
          ))}
        </ol>
      )}

      <p className="quiz-review-back">
        <button type="button" className="link-like" onClick={goBack}>
          ← Назад
        </button>
        {' · '}
        <Link to="/my-lessons" className="link-like">Журнал занятий</Link>
      </p>
    </div>
  );
}
